/**
 * Confirm Resume Batch Modal Component
 * Confirmation dialog for clearing end date to resume a completed batch
 */

import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface ConfirmResumeBatchData {
    batchNumber?: string;
    equipmentName?: string;
}

@Component({
    selector: 'app-confirm-resume-batch-modal',
    templateUrl: './confirm-resume-batch-modal.component.html',
    styleUrls: ['./confirm-resume-batch-modal.component.scss'],
  standalone: false
})
export class ConfirmResumeBatchModalComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmResumeBatchModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmResumeBatchData
    ) { }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }
}
